import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class SiteStatVm {
	name?: string;
	emergencyEvent?: string;
	team?: string;
	numberOfAssets: number;
	numberOfPersonnel: number;
	client?: string;
	totalDispenseEvents: number;
	fuelStats?: any;
	personnelOverview?: any;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'name': new UntypedFormControl(null, [...(validators['name'] ?? []), ...[]]),
			'emergencyEvent': new UntypedFormControl(null, [...(validators['emergencyEvent'] ?? []), ...[]]),
			'team': new UntypedFormControl(null, [...(validators['team'] ?? []), ...[]]),
			'numberOfAssets': new UntypedFormControl(0, [...(validators['numberOfAssets'] ?? []), ...[Validators.required]]),
			'numberOfPersonnel': new UntypedFormControl(0, [...(validators['numberOfPersonnel'] ?? []), ...[Validators.required]]),
			'client': new UntypedFormControl(null, [...(validators['client'] ?? []), ...[]]),
			'totalDispenseEvents': new UntypedFormControl(0, [...(validators['totalDispenseEvents'] ?? []), ...[Validators.required]]),
			'fuelStats': new UntypedFormControl(null, [...(validators['fuelStats'] ?? []), ...[]]),
			'personnelOverview': new UntypedFormControl(null, [...(validators['personnelOverview'] ?? []), ...[]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): SiteStatVmFromFg {
		return new SiteStatVmFromFg(fg);
	}
}

export class SiteStatVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get name(): string {
		return this.fg.get('name').value;
	}
	set name(val) {
		this.fg.get('name').setValue(val);
	}

	get emergencyEvent(): string {
		return this.fg.get('emergencyEvent').value;
	}
	set emergencyEvent(val) {
		this.fg.get('emergencyEvent').setValue(val);
	}

	get team(): string {
		return this.fg.get('team').value;
	}
	set team(val) {
		this.fg.get('team').setValue(val);
	}

	get numberOfAssets(): number {
		return this.fg.get('numberOfAssets').value;
	}
	set numberOfAssets(val) {
		this.fg.get('numberOfAssets').setValue(val);
	}

	get numberOfPersonnel(): number {
		return this.fg.get('numberOfPersonnel').value;
	}
	set numberOfPersonnel(val) {
		this.fg.get('numberOfPersonnel').setValue(val);
	}

	get client(): string {
		return this.fg.get('client').value;
	}
	set client(val) {
		this.fg.get('client').setValue(val);
	}

	get totalDispenseEvents(): number {
		return this.fg.get('totalDispenseEvents').value;
	}
	set totalDispenseEvents(val) {
		this.fg.get('totalDispenseEvents').setValue(val);
	}

	get fuelStats(): any {
		return this.fg.get('fuelStats').value;
	}
	set fuelStats(val) {
		this.fg.get('fuelStats').setValue(val);
	}

	get personnelOverview(): any {
		return this.fg.get('personnelOverview').value;
	}
	set personnelOverview(val) {
		this.fg.get('personnelOverview').setValue(val);
	}
}
